import { FooterButtonsProps } from './types';
import * as S from './styles';

export const FooterButtons = ({ children }: FooterButtonsProps) => <S.Container>{children}</S.Container>;
